import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-subscription-suspended',
  templateUrl: './subscription-suspended.component.html',
  styleUrls: ['./subscription-suspended.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class SubscriptionSuspendedComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }
}
